/** PowurOS Proposal Inputs `utilities[].acceptsNonExportSystems`. */
export const NonExportAcceptance = {
  Required: 1,
  Allowed: 2,
  Disallowed: 3,
} as const

export type NonExportAcceptance =
  (typeof NonExportAcceptance)[keyof typeof NonExportAcceptance]

const NON_EXPORT_ACCEPTANCE_VALUES: readonly unknown[] =
  Object.values(NonExportAcceptance)

export const isNonExportAcceptance = (
  value: unknown,
): value is NonExportAcceptance => NON_EXPORT_ACCEPTANCE_VALUES.includes(value)

export type BatterySystemTypeValue = `export` | `non_export`

type AllowedBatterySystemTypes = readonly [
  BatterySystemTypeValue,
  ...BatterySystemTypeValue[],
]

const BOTH: AllowedBatterySystemTypes = [`export`, `non_export`]
const EXPORT_ONLY: AllowedBatterySystemTypes = [`export`]
const NON_EXPORT_ONLY: AllowedBatterySystemTypes = [`non_export`]

/**
 * The Battery System Types the Utility Company permits. PowurOS returns one
 * utility per inputs response, so only the first entry is read.
 *
 * - Missing utilities (`null` / `undefined`) mean inputs have not arrived, so
 *   both types stay available.
 * - An empty list after inputs load fails closed to Export.
 *
 * When one type is returned, it is the one to preselect.
 */
export const allowedBatterySystemTypes = (
  utilities:
    | ReadonlyArray<{ acceptsNonExportSystems: NonExportAcceptance }>
    | null
    | undefined,
): AllowedBatterySystemTypes => {
  if (utilities == null) {
    return BOTH
  }

  switch (utilities[0]?.acceptsNonExportSystems) {
    case NonExportAcceptance.Required:
      return NON_EXPORT_ONLY
    case NonExportAcceptance.Allowed:
      return BOTH
    default:
      return EXPORT_ONLY
  }
}
